import {downloadFile, get, post} from './Tools';

const emit = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}timbrado_nomina/emit`, payload);
  return response;
};

const emitFinquito = async (finiquito_id) => {
  const response = await post(`${process.env.REACT_APP_SERVER}timbrado_nomina/emit-finiquito`, {finiquito_id});
  return response;
};

// const emit = async (payload) => {
//   const response = await get(`${process.env.REACT_APP_SERVER}timbrado_nomina/emit/${payload.periodo_id}/${payload.anio}/${payload.num_periodo}`);
//   return response;
// };

const downloadRecibo = async (file, periodo, anio, num_periodo, odoo_empleado_id) => {
  const response = await downloadFile(`${process.env.REACT_APP_SERVER}timbrado_nomina/get_file/${file}/${periodo}/${anio}/${num_periodo}/${odoo_empleado_id}`, `${periodo}-${anio}-${num_periodo}-${odoo_empleado_id}.${file}`);
  return response;
};

const uploadXml = async (payload) => {
  const response = await post(
    `${process.env.REACT_APP_SERVER}timbrado_nomina/upload-xml`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response;
};


const downloadFiniquito = async (file, finiquito_id) => {
  const response = await downloadFile(`${process.env.REACT_APP_SERVER}timbrado_nomina/get_file/${file}/${finiquito_id}`, `${finiquito_id}.${file}`);
  return response;
};


export { emit, uploadXml, emitFinquito, downloadRecibo, downloadFiniquito };
